import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import useDocumentTitle from "../../hooks/useDocumentTitle";
import { useDispatch, useSelector } from "react-redux";
import paths from "../../constants/paths";
import { fetchThankYou } from "../../states/actions/jobAlerts";
import Text from "../common/Text";
import LoadingScreen from "../common/LoadingScreen";
const Thankyou = () => {
  // const siteSettings = useSelector(
  //   (state) => state.fetchSiteSettings.siteSettings
  // );
  const dispatch = useDispatch();
  const data = useSelector((state) => state.fetchJobAlerts.content);
  const isLoading = useSelector((state) => state.fetchJobAlerts.isLoading);
  const isSiteSettingsLoading = useSelector(
    (state) => state.fetchSiteSettings.isLoading
  );
  useEffect(() => {
    dispatch(fetchThankYou());
  }, []);

  const { page_title, content } = data;
  useDocumentTitle(page_title);
  return (
    <>
      {isLoading || isSiteSettingsLoading ? (
        <LoadingScreen />
      ) : (
        <>
          <main>
            <section className="thanks">
              <div className="contain">
                <div className="inner">
                  <div className="inside">
                    <div className="heading">
                      {/* <h2>Success!🎉</h2> */}
                      <h2>{content?.banner_heading}</h2>
                    </div>
                    <div className="content">
                      <Text string={content?.detail} parse={true} />
                      {/* <p>
                    Thank you for subscribing to UK Visa Jobs.
                    <br />
                    You membership grants you access to exclusive content,
                    tailored updates and offers available only to our community.
                  </p> */}
                      <ul>
                        <li>
                          <a
                            href={paths.SITE_BASE_URL + "/open-jobs/1"}
                            className="site_btn"
                          >
                            Explore Jobs
                          </a>
                        </li>
                        <li>
                          <a
                            href={paths.SITE_BASE_URL + "/dashboard"}
                            className="site_btn blank_btn"
                          >
                            Visit Dashboard
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
        </>
      )}
    </>
  );
};

export default Thankyou;
